var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTradePair = function SvgTradePair(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.189 7.35a4.16 4.16 0 0 1 8.28-.595h1.198a5.35 5.35 0 1 0-5.912 5.912v-1.199A4.162 4.162 0 0 1 3.19 7.35ZM12.667 18a5.333 5.333 0 1 0 0-10.667 5.333 5.333 0 0 0 0 10.667Z",
    fill: "#666"
  })));
};
export default SvgTradePair;